<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('InfoLineTool', function() {
            return {
                // Descriptor for the tool
                group: 'Lines', category: 'Lines', icon: 'line.svg',
                type: 'Info',
                name: 'Info Line',
                hint: 'Draw an Info Line with labels',
                data: [],     // Default data
                settings: {}  // Default settings
            }
        }, 'Info Line')
</script>
